import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BookOpen } from "lucide-react";
import { api } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const BookPicker = ({ onChange, canEdit }) => {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/book").then((r) => setCfg(r.data)).catch(() => {});
  }, [canEdit]);

  if (!cfg) return null;

  const pick = async (book) => {
    if (!canEdit) {
      toast.error("Sign in to change the sportsbook");
      return;
    }
    setSaving(true);
    try {
      await api.post("/settings/book", { book });
      setCfg((c) => ({ ...c, book }));
      toast.success(`Showing ${cfg.books.find((b) => b.key === book)?.title} lines`);
      onChange?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not switch sportsbook");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="book-picker">
      <BookOpen className="h-4 w-4 text-slate-500" />
      <Select value={cfg.book} onValueChange={pick} disabled={saving}>
        <SelectTrigger
          data-testid="book-picker-trigger"
          className="h-9 w-[140px] bg-[#141C2B] border-[#00E5FF]/30 text-slate-200 text-sm"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {cfg.books.map((b) => (
            <SelectItem key={b.key} value={b.key} data-testid={`book-option-${b.key}`}>
              {b.title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <span data-testid="odds-provider-label" className="hidden sm:inline font-data text-[10px] uppercase tracking-wide text-slate-500">
        via {cfg.provider === "opticodds" ? "OpticOdds" : "The Odds API"}
      </span>
    </div>
  );
};
